import React from 'react';

const GripVerticalIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <circle cx="9" cy="12" r="1"/>
            <circle cx="9" cy="5" r="1"/>
            <circle cx="9" cy="19" r="1"/>
            <circle cx="15" cy="12" r="1"/>
            <circle cx="15" cy="5" r="1"/>
            <circle cx="15" cy="19" r="1"/>
        </svg>
    );
};

export default GripVerticalIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/GripVerticalIcon.jsx